import Vue from 'vue'

import VueTheMask from 'vue-the-mask'
import VuetifyMoney from 'vuetify-money'

Vue.use(VueTheMask)
Vue.use(VuetifyMoney)
